import { apiJson } from './apiClient';

/**
 * Shareable URL encoding/decoding.
 *
 * New shares are stored server-side and exposed as ?share=<id>. Legacy ?song=<base64>
 * links are still decoded so older shared songs keep loading.
 */

const PARAM = 'song';
const SHARE_PARAM = 'share';

export function encodeSongToUrl({ title, lyrics, alignment, songKey, bpm, transposition, capo }) {
  const data = { title, lyrics, alignment, songKey, bpm, transposition, capo };
  try {
    const json = JSON.stringify(data);
    const encoded = btoa(encodeURIComponent(json));
    return encoded;
  } catch {
    return null;
  }
}

export function decodeSongFromUrl(encoded) {
  try {
    const json = decodeURIComponent(atob(encoded));
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export async function buildShareUrl(songData) {
  const data = await apiJson('/shares', {
    method: 'POST',
    body: JSON.stringify(songData),
  });
  if (!data.shareId) return null;
  const url = new URL(window.location.href);
  url.search = '';
  url.searchParams.set(SHARE_PARAM, data.shareId);
  return url.toString();
}

export function readLegacySongFromCurrentUrl() {
  const params = new URLSearchParams(window.location.search);
  const encoded = params.get(PARAM);
  if (!encoded) return null;
  return decodeSongFromUrl(encoded);
}

export async function readSharedSongFromCurrentUrl() {
  const params = new URLSearchParams(window.location.search);
  const shareId = params.get(SHARE_PARAM);
  if (shareId) {
    const data = await apiJson(`/shares/${encodeURIComponent(shareId)}`);
    return data.song || null;
  }
  return readLegacySongFromCurrentUrl();
}
